import React from 'react'
import { TableCell } from '../ui/table'
import { TableBody } from '../ui/table'
import { TableHead, TableHeader, TableRow } from '../ui/table'
import { HoverCard, HoverCardContent, HoverCardTrigger } from '../ui/hover-card'
import { Table } from '../ui/table'
import { formatToRupee } from '@/lib/internalApis'
import { useQuery } from '@tanstack/react-query'
import useAuthStore from '@/lib/useAuthStore'
import api from '@/app/api'

interface ApiBalanceResponse {
    success: boolean;
    BalanceData: {
        totalBalance: number;
        walletBalance: number;
    };
}

const TJApiBalance = () => {
    const { user }: any = useAuthStore();

    const apiBalance = async (): Promise<ApiBalanceResponse> => {
        const response = await api.get<ApiBalanceResponse>(`/wallet/api-balance`);
        return response.data;
    }
    const { data: apiBalanceData } = useQuery({
        queryKey: ['apiBalance'],
        queryFn: () => apiBalance()
    })
    return (<>
        {user?.role_type === "SUPER_ADMIN" && apiBalanceData && <HoverCard openDelay={100}>
            <HoverCardTrigger asChild>
                <div className="text-[#084A76] text-[14px] py-1 px-2 hover:cursor-pointer">
                    <span>TJ API Balance</span>
                </div>
            </HoverCardTrigger>
            <HoverCardContent className="w-[400px] mr-10">
                <div className="rounded-md w-full bg-white">
                    <Table>
                        <TableHeader>
                            <TableRow className="bg-[#084A76]">
                                <TableHead className="!text-[10px] !font-semibold !text-white hover:!text-black text-center">BALANCE TYPE</TableHead>
                                <TableHead className="!text-[10px] !font-semibold !text-white hover:!text-black text-center">AMOUNT</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            <TableRow className="!text-[12px] bg-muted/100 text-black font-light">
                                <TableCell className="text-center">Total Balance</TableCell>
                                <TableCell className="text-center">{formatToRupee(apiBalanceData?.BalanceData?.totalBalance)}</TableCell>
                            </TableRow>
                            <TableRow className="!text-[12px] bg-muted/100 text-black font-light">
                                <TableCell className="text-center">Wallet Balance</TableCell>
                                <TableCell className="text-center">{formatToRupee(apiBalanceData?.BalanceData?.walletBalance)}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </div>
            </HoverCardContent>
        </HoverCard>}
    </>
    )
}

export default TJApiBalance